import { useFnProxy, useFollow } from '@lc/libreact'
import { useEffect } from 'react'

export function useClickOut(
	...args: [...{ readonly current: Node | null }[], (e: MouseEvent) => void]
): void {
	const handler = args.at(-1)! as (e: MouseEvent) => void
	const refs = args.slice(0, -1) as { readonly current: Node | null }[]

	const refsFollow = useFollow(refs)
	const handlerProxy = useFnProxy(handler)

	useEffect(() => {
		const controller = new AbortController()

		document.addEventListener(
			'click',
			e => {
				const nodes = new Set(
					refsFollow.current.map(ref => ref.current).filter(Boolean),
				)
				let target = e.target as Node | null
				for (;;) {
					if (!target) break
					if (nodes.has(target)) return
					target = target.parentNode
				}
				handlerProxy(e)
			},
			{ signal: controller.signal },
		)

		return () => void controller.abort()
	}, [refsFollow, handlerProxy])
}
